import Vue from 'vue';
const SEC = require('common/js/utils/core.js');
const API_SHOPPING_CART = process.env.API_SHOPPING_CART || '';

// 获取upk
const UPK = SEC.cookie.get('Sid') || process.env.UPK;

// 购物车渠道--1:iphone 2:android 3:ipad 4:iPad_reserve 5:wap
const AID = 5;
// 客户端标识
const CLIENT = 'iphone';
// 购物车类型  0: 普通购物车; 1: IPAD店面预定购物车; 2:IPAD扫码购物车
const CARTTYPE = 0;


/**
 *
 * 获取购物车数据（查看购物车）
 *
 *
 * */
export function api_getShoppingCartData() {
    const API = `${API_SHOPPING_CART}/api/cart/cart`;
    const productInfo = localStorage.getItem('cartData');
    return Vue.http.get(API, {
        params: {
            action: 0, // 0是查看购物车，1是添加，2是更新，3是删除，4是选中
            aid: AID, // 购物车渠道
            cartType: CARTTYPE,
            client: CLIENT,
            v: '2.0',
            openCloud: 1, // 是否开启云端购物车（1：开启 0：关闭）
            products: productInfo || '[]', // 未开启云端的购物车商品信息
            upk: UPK,
            c_platform_type: '0' // 手机系统(0:ios；1:android；2:H5；3:WAP;4:pc;5小程序)
        }
    });
}

/**
 * 修改商品的选中状态
 *
 *
 * choseProductInfo {string}      要修改的商品信息
 * isChecked        {number}      是否选中 0:未选中 1:选中
 *
 *
 * */
export function api_changeSelectStatus(choseProductInfo, isChecked) {
    const API = `${API_SHOPPING_CART}/api/cart/cart`;
    const productInfo = UPK ? '[]' : localStorage.getItem('cartData');
    return Vue.http.get(API, {
        params: {
            aid: AID,
            action: 4, // 0是查看购物车，1是添加，2是更新，3是删除，4是选中
            cartType: CARTTYPE,
            client: CLIENT,
            isChecked: isChecked,
            v: '1.0',
            openCloud: 1,
            products: productInfo || '[]',
            choseProducts: choseProductInfo || '[]',
            upk: UPK,
            c_platform_type: '0' // 手机系统(0:ios；1:android；2:H5；3:WAP;4:pc;5小程序)
        }
    });
}

/**
 * 修改商品数量
 *
 *
 * itemKey   {string} 要修改数量的商品
 * quantity  {number} 要修改的商品的数量
 *
 * */
export function api_changeProductQuantity(itemKey, quantity) {
    const API = `${API_SHOPPING_CART}/api/cart/cart`;
    const productInfo = UPK ? '[]' : localStorage.getItem('cartData');
    return Vue.http.get(API, {
        params: {
            action: 2, // 0是查看购物车，1是添加，2是更新，3是删除，4是选中
            aid: AID,
            cartType: CARTTYPE,
            client: CLIENT,
            v: '1.0',
            openCloud: 1,
            products: productInfo || '[]',
            itemKey: itemKey,
            quantity: quantity,
            upk: UPK,
            c_platform_type: '0' // 手机系统(0:ios；1:android；2:H5；3:WAP;4:pc;5小程序)
        }
    });
}

/**
 * 删除购物车商品
 *
 *
 * itemKey {string} 要修改数量的商品的itemKey,如果有多个，中间用英文逗号隔开
 *
 * */
export function api_deleteProduct(itemKey) {
    const API = `${API_SHOPPING_CART}/api/cart/cart`;
    // 本地的购物车数据
    const productInfo = UPK ? '[]' : localStorage.getItem('cartData');
    return Vue.http.get(API, {
        params: {
            aid: AID,
            action: 3, // 0是查看购物车，1是添加，2是更新，3是删除，4是选中
            cartType: CARTTYPE,
            client: CLIENT,
            v: '2.0',
            openCloud: 1,
            itemKey: itemKey,
            products: productInfo || '[]',
            upk: UPK,
            c_platform_type: '0' // 手机系统(0:ios；1:android；2:H5；3:WAP;4:pc;5小程序)
        }
    });
}

/**
 * 获取推荐商品
 *
 *
 *
 * */
export function api_getRecommendProducts() {
    const API = `${API_SHOPPING_CART}/api/recommend/recommend?type=buy-buy`;

    return Vue.http.get(API, {
        params: {
            count: 40, // 返回商品数量，取40个
            from: 'cart', // 推荐来源位置cart
            c_platform_type: '0' // 手机系统(0:ios；1:android；2:H5；3:WAP;4:pc;5小程序)
        }
    });
}



// WEBPACK FOOTER //
// ./src/api/index.js